var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"message-fade"},on:{"after-leave":_vm.handleAfterLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMyMessage),expression:"isShowMyMessage"}],class:[
      'messageBox',
      _vm.center ? 'horizontal' : '',
      _vm.typeArr.includes(_vm.type) ? _vm.type : '',
    ],style:(_vm.controlTop),on:{"mouseenter":_vm.clearTimerFn,"mouseleave":_vm.startTimerFn}},[_c('span',[_vm._v(" "+_vm._s(_vm.iconObj[_vm.type])+" "+_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }